<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.identification' | translate }}</label>
    <input
      appInput
      type="text"
      formControlName="meteringPointIdentification"
      [placeholder]="'meteringpoint.identification' | translate"
      [readonly]="knownMeteringPoint"
      autofocus
    >
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.masterdata.from' | translate }}</label>
    <input appInput
           type="date"
           formControlName="validFrom"
           [placeholder]="'meteringpoint.masterdata.from' | translate"
    >
  </app-input-group>
</form>
